


























































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {InputAdminConfigInternationalSchema} from '@/schema/resource/AdminConfig/InputAdminConfigInternationalSchema'
import {AdminConfigInternational} from '@/model/resource/AdminConfigInternational'

@Component
export default class PersistAdminConfigInternationalView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator
  Helper = Helper
  schema = new InputAdminConfigInternationalSchema()
  adminConfigInternational = new AdminConfigInternational()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.adminConfigInternational.getAdminConfig(id)
    }

    $.await.done('getAdminConfig')
  }

  async persist() {
    const {isSenhaPainelMatch} = this.schema
    const isValid = (await this.validator.validateAll()) && isSenhaPainelMatch

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    this.adminConfigInternational.idAdministradorFk =
      this.$auth.administrador?.idAdministradorPk ?? 0
    await this.adminConfigInternational.persistAdminConfig()
    await Helper.success('system.success.persist')
  }
}
